import * as Yup from "yup";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ModuleLayout from "./ModuleLayout/ModuleLayout";

const initialValues = { name: "" };
const fields = [{ name: "name", label: "Location Name", type: "text", placeholder: "Container 1" }];
const validationSchema = Yup.object({
  name: Yup.string().trim().required("Location name is required").max(100, "Use up to 100 characters"),
});

function Locations() {
  return (
    <ModuleLayout
      moduleName="Locations"
      moduleKey="locations"
      icon={<LocationOnIcon sx={{ fontSize: 34, color: "white" }} />}
      initialFormValues={initialValues}
      formFields={fields}
      validationSchema={validationSchema}
      onBeforeSave={(values) => ({ _id: values._id, name: values.name.trim() })}
      columns={[
        { field: "serial", headerName: "Sr. #", width: 70, sortable: false },
        { field: "name", headerName: "Location Name", minWidth: 200 },
      ]}
      searchFilter={(location, search) => location.name.toLowerCase().includes(search.toLowerCase())}
      sortFunction={(a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base", numeric: true })}
      getItemName={(location) => location?.name || ""}
      breadcrumbs={[
        { label: "Home", path: "/user/dashboard", icon: <HomeIcon sx={{ mr: 0.5, fontSize: 20 }} /> },
        { label: "Settings", path: "/user/settings", icon: <SettingsIcon sx={{ mr: 0.5, fontSize: 20 }} /> },
        { label: "Locations", path: null },
      ]}
      moduleDescription="Manage storage locations so you can find your tires when you need them."
      deleteWarning="Deleting this location clears its assignment from stored tires. The tires and their stock quantities will be kept."
    />
  );
}

export default Locations;
